// import { styled } from "@mui/material/styles";
// import { AppBar, IconButton, Drawer, List } from "@mui/material";

// const drawerWidth = 220;

// export const useAppStyles = () => {
//   const Root = styled('div')(({ theme }) => ({
//     display: "flex",
//     color: "black",
//   }));

//   const AppBarStyled = styled(AppBar)(({ theme, open }) => ({
//     zIndex: theme.zIndex.drawer + 1,
//     ...(open && {
//       marginLeft: drawerWidth,
//       width: `calc(100% - ${drawerWidth}px)`,
//     }),
//   }));

//   const MenuButton = styled(IconButton)(({ theme, open }) => ({
//     marginRight: 12,
//     ...(open && {
//       display: "none",
//     }),
//   }));

//   const DrawerStyled = styled(Drawer)(({ theme, open }) => ({
//     width: drawerWidth,
//     flexShrink: 0,
//     whiteSpace: "nowrap",
//     color: "white",
//     backgroundColor: "white",
//     ...(open && {
//       width: drawerWidth,
//       color: "white",
//     }),
//     ...(!open && {
//       transition: theme.transitions.create("width", {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.leavingScreen,
//       }),
//       color: "white",
//       backgroundColor: "white",
//       overflowX: "hidden",
//       width: theme.spacing(7) + 1,
//       [theme.breakpoints.up("sm")]: {
//         width: theme.spacing(9) + 1,
//       },
//     }),
//     '& .MuiDrawer-paper': {
//       boxSizing: 'border-box',
//       overflowX: 'hidden',
//       width: open ? drawerWidth : theme.spacing(7) + 1,
//       [theme.breakpoints.up('sm')]: {
//         width: open ? drawerWidth : theme.spacing(9) + 1,
//       },
//     },
//   }));

//   const ToolbarStyled = styled('div')(({ theme }) => ({
//     color: "white",
//     backgroundColor: "#4e9a98",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "flex-end",
//     padding: theme.spacing(0, 1),
//     ...theme.mixins.toolbar,
//   }));

//   const SideMenu = styled(List)(({ theme }) => ({
//     color: "#9acad6",
//     backgroundColor: "#4e9a98",
//     height: "100vh",
//   }));

//   const SideMenuItem = styled('div')(({ theme }) => ({
//     padding: "0.625rem 0",
//   }));

//   const CustomWidth = styled('div')(({ theme }) => ({
//     backgroundColor: "#4e9a98",
//     paddingRight: "0px",
//     display: "flex",
//     alignItems: "center",
//   }));

//   const Content = styled('main')(({ theme }) => ({
//     flexGrow: 1,
//     padding: "56px 56px 56px 90px",
//     // padding: theme.spacing(7),
//   }));

//   return {
//     Root,
//     AppBarStyled,
//     MenuButton,
//     DrawerStyled,
//     ToolbarStyled,
//     SideMenu,
//     SideMenuItem,
//     CustomWidth,
//     Content,
//   };
// };

import { styled } from "@mui/material/styles";
import { AppBar, IconButton, Drawer, List } from "@mui/material";

const drawerWidth = 220;

export const useAppStyles = () => {
  const Root = styled("div")(({ theme }) => ({
    display: "flex",
    color: "black",
  }));

  const AppBarStyled = styled(AppBar)(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
    }),
  }));

  const MenuButton = styled(IconButton)(({ theme, open }) => ({
    marginRight: 12,
    ...(open && {
      display: "none",
    }),
  }));

  const DrawerStyled = styled(Drawer)(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    color: "white",
    backgroundColor: "white",
    ...(open && {
      width: drawerWidth,
      color: "white",
    }),
    ...(!open && {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      color: "white",
      backgroundColor: "white",
      overflowX: "hidden",
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
    "& .MuiDrawer-paper": {
      boxSizing: "border-box",
      overflowX: "hidden",
      width: open ? drawerWidth : theme.spacing(7) + 1,
      [theme.breakpoints.up("sm")]: {
        width: open ? drawerWidth : theme.spacing(9) + 1,
      },
    },
  }));

  const ToolbarStyled = styled("div")(({ theme }) => ({
    color: "white",
    backgroundColor: "#4e9a98",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 2),
    ...theme.mixins.toolbar,
  }));

  const SideMenu = styled(List)(({ theme }) => ({
    color: "#9acad6",
    backgroundColor: "#4e9a98",
    height: "100vh",
  }));

  const SideMenuItem = styled("div")(({ theme }) => ({
    // padding: " 0.625rem 0",
    padding: "0 0",
  }));

  const CustomWidth = styled("div")(({ theme }) => ({
    backgroundColor: "#4e9a98",
    paddingRight: "0px",
    display: "flex",
    alignItems: "center",
  }));

  const Content = styled("main", {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    flexGrow: 1,
    transition: "padding 0.3s ease",
    ...(open
      ? {
          padding: theme.spacing(7),
        }
      : {
          padding: "56px 56px 56px 56px",
        }),
  }));

  return {
    Root,
    AppBarStyled,
    MenuButton,
    DrawerStyled,
    ToolbarStyled,
    SideMenu,
    SideMenuItem,
    CustomWidth,
    Content,
  };
};
